import { useRouteError } from "react-router";
import { useTranslation } from 'react-i18next';

interface RouteError {
  statusText?: string;
  message?: string;
}

export default function ErrorPage() {
  const { t } = useTranslation();
  const error = useRouteError() as RouteError | null;
  console.error(error);

  return (
    <div id="error-page">
      <h1>{t('error.title')}</h1>
      <p>{t('error.message')}</p>
      <p>
        <i>{error?.statusText || error?.message}</i>
      </p>
    </div>
  );
}
